import API from './index';
import AppUrls from '../config/AppUrls';
import { PanelType, pathFolder } from '../utils/Constants';
import { buildPathWithParams } from '../utils/Paths';
import { downloadPDF } from '../utils/Functions';

class ReferralService {
  static signUpOlaclickReferral(referral) {
    return API.post(AppUrls.api.olaclickReferral, referral.data).then((response) => response);
  }

  static signUpOrderEatReferral(referral) {
    return API.post(AppUrls.api.orderEatReferral, referral.data).then((response) => response);
  }

  static signUpGenericReferral(data) {
    return API.post(AppUrls.api.genericReferral, { ...data }).then((response) => {
      return response.data;
    });
  }

  static downloadFileTC = async (cb, name) => {
    cb(true);
    const path = pathFolder.examples;
    const response = await API.get(
      buildPathWithParams(AppUrls.api.SingUpReferralDownloadFile, {
        name,
        path,
      })
    );
    downloadPDF(response.data, name);
    cb && cb(false);
  };

  static updateReferredMerchantFee(data) {
    const { mainMerchantId, subMerchantId, newMarkUpFee } = data;
    const request = {
      subMerchantId,
      fee: newMarkUpFee,
    };
    const url = buildPathWithParams(AppUrls.api.referredMerchantEditFee, {
      mainMerchantId,
    });
    return API.put(url, request).then((response) => response.data);
  }

  static createReferralMerchantStg(data) {
    const { fullName, email, companyName, mainMerchantId } = data;
    const request = {
      fullName,
      email,
      companyName,
      mainMerchantId,
      referral: true,
      panelType: PanelType.DIRECTA,
    };
    return API.post(AppUrls.api.createReferralMerchantStg, request).then((response) => response.data);
  }

  static updateReferralData(idMerchant, data) {
    const url = buildPathWithParams(AppUrls.api.referralConfig, {
      idMerchant,
    });
    return API.put(url, data).then((response) => response.data);
  }

  static fetchReferralConfig(idMerchant, params = {}) {
    const url = buildPathWithParams(AppUrls.api.referralConfig, {
      idMerchant,
    });
    return API.get(url, params).then((response) => response.data);
  }
}

export default ReferralService;
